














import { Component, Mixins } from "vue-property-decorator";
import { CommonComponentsAccessibleMixin } from "../../mixins";
import { DomainRegistry } from "../../../../../domain";
import { IConfiguration } from "../../../../../domain/configuration";
import { EditableFormatSummary, FormatStructureEditor } from "../../../../../domain/editableFormat";

@Component({
  components: {
    FormatReferrer: () => import("../../FormatReferrer.vue")
  }
})
export default class FormatCreatedFormatTool extends Mixins(CommonComponentsAccessibleMixin) {
  $configuration!: IConfiguration;
  selectedFormat: EditableFormatSummary = null;
  isLoading: boolean = false;
  model: FormatStructureEditor = null;

  get formatName(): string {
    return this.selectedFormat
      ? this.selectedFormat.name
      : "";
  }

  get description(): string {
    return "ダイアログを表示して参照する" + this.$wording.format.name + "を選択します。";
  }

  async onClick() {
    const result = await this.getCommonComponents().getDialogs().getFormatSelectDialog().show();
    if (!result) {
      return;
    }
    this.selectedFormat = result;
    this.load();
  }

  private async load(): Promise<void> {
    this.isLoading = true;
    const registry = DomainRegistry.instance;
    const format = await registry.editableFormat.getFormatRepository().getFormatStructure(this.selectedFormat.id);
    const version = format.version
      ? format.version
      : "3.00";
    const specification = await registry.editableFormat.getSpecificationRepository().getSpecification(version);
    this.isLoading = false;
    this.model = new FormatStructureEditor(format, specification);
    this.model.setCommandCountMax(this.$configuration.formatEditor.behavior.format.editor.commandManager.max);
  }

  get isLoadedModel(): boolean {
    return !this.isLoading && !!this.model;
  }
}
